import React, { useContext } from "react";

import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import { useHistory } from "react-router-dom";
import messages from "../services/messages";
import ShareDialog from "./ShareDialog";
import LanguageContext from "../LanguageContext";
import JWTTokenContext from "../JWTTokenContext";
import CardMedia from "@mui/material/CardMedia";
import ButtonBase from "@mui/material/ButtonBase";
import UserService from "../services/UserService";
import firebase from "../firebase";
import { Schedule } from "@mui/icons-material";
import { WhatsappShareButton } from "react-share";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
    width: theme.spacing(36),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  authorContainer: {},
  contentContainer: {
    height: "115px",
  },
  shareIconContainer: {
    // marginTop: theme.spacing(1),
  },
  shareIcon: {
    marginTop: theme.spacing(1.7),
    height: theme.spacing(2.5),
  },
  headerContainer: {
    cursor: "pointer",
    height: "100px",
  },
  playButtonBase: {
    top: theme.spacing(-8),
    left: theme.spacing(5),
    marginBottom: theme.spacing(-5),
  },
  playButton: {
    width: "48px",
    height: "48px",
    opacity: "0.9",
  },
  cropImageContainer: {
    marginBottom: theme.spacing(-3),
  },
  scheduleIcon: {
    marginBottom: theme.spacing(-0.6),
    height: theme.spacing(2.5),
  },
  cropImage: {
    marginLeft: theme.spacing(3),
  },
  avatar: { width: theme.spacing(3.5), height: theme.spacing(3.5) },
  authorName: {
    marginLeft: theme.spacing(-1),
  },
}));

export default function RecordedContentCard(props) {
  const classes = useStyles();
  const [openShareDialog, setOpenShareDialog] = React.useState(false);
  let history = useHistory();
  const [openVideoDialog, setOpenVideoDialog] = React.useState(false);
  const { mobile } = UserService.getUserInfo();

  const handleClickOpen = () => {
    setOpenShareDialog(true);
  };
  const language = useContext(LanguageContext);
  const jwtToken = useContext(JWTTokenContext);

  const handleClose = (value) => {
    setOpenShareDialog(false);
  };

  const getShareText = () => {
    let shareText = `🎥 ${props.recordedMeeting.cropName}  ${messages["cropPage.recording.shareText1"][language]} ${props.recordedMeeting.sessionTopic}  ${messages["cropPage.recording.shareText2"][language]} `;

    return shareText;
  };

  const share = async (event) => {
    event.stopPropagation();
    firebase.analytics().logEvent("recorded_class_shared_on_whatsapp", {
      mobile,
      crop_name: props.recordedMeeting.crop.name_en,
      author_name: props.recordedMeeting.author.name_en,
      session_topic: props.recordedMeeting.sessionTopic,
      week: props.recordedMeeting.week,
      position: props.position,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      state: props?.recordedMeeting?.state[0].name_en,
      class_start_time: props.recordedMeeting.startTime,
      user_source: props?.userSource,
    });
  };

  const handleOpenVideoDialog = () => {
    setOpenVideoDialog(true);
    UserService.logVideoplay(
      props.recordedMeeting.cropName,
      props.recordedMeeting.authorName,
      props.recordedMeeting.week,
      props.recordedMeeting.sessionTopic,
      language
    );
    history.push({
      pathname: `${props.recordedMeeting.crop.name_en}/recordings/${props.recordedMeeting.id}`,
      state: {
        recordedMeeting: props.recordedMeeting,
        mobile: mobile,
        farmerCrops: props.farmerCrops,
        position: props.position,
        jwtToken: jwtToken,
        userType: props.userType,
        userState: props.userState,
        userSource: props.userSource,
      },
    });
  };
  //
  const handleCloseVideoDialog = (value) => {
    setOpenVideoDialog(false);

    firebase.analytics().logEvent("recorded_class_dialog_closed", {
      crop_name: props.crop_name_en,
      author_name: props.author_name_en,
      session_topic: props.session_topic,
      week: props.week,
      mobile,
      position: props.position,
      class_start_time: props.class_start_time,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      state: props.userState,
      user_source: props?.userSource,
    });
  };

  return <>
    <Card
      className={classes.root}
      onClick={handleOpenVideoDialog}
      variant={"outlined"}
    >
      <div
        style={{
          backgroundColor: props.recordedMeeting.crop.color,
        }}
      >
        <CardContent className={classes.headerContainer}>
          {props.recordedMeeting.video && (
            <Grid
              container
              direction="row"
              justifyContent={"flex-start"}
              alignItems={"stretch"}
            >
              <Grid item xs={8}>
                <Grid item>
                  <Typography variant={"h6"}>
                    {props.recordedMeeting.cropName}
                    {props.recordedMeeting.week &&
                      props.recordedMeeting.week !== "" && <> &bull; </>}
                    {props.recordedMeeting.week}
                  </Typography>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-end"
                >
                  <Grid item xs={12}>
                    <Typography variant={"body2"}>
                      <Schedule className={classes.scheduleIcon} />{" "}
                      {props.recordedMeeting.startTime}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3} className={classes.cropImageContainer}>
                <>
                  <CardMedia
                    component="img"
                    height="70"
                    className={classes.cropImage}
                    image={props.recordedMeeting.cropImage}
                    alt={props.recordedMeeting.cropName}
                    title={props.recordedMeeting.cropName}
                  />
                  <ButtonBase
                    centerRipple={true}
                    focusRipple={true}
                    aria-label="play"
                    className={classes.playButtonBase}
                    size="medium"
                  >
                    <img
                      src="../../icons/playcircle.svg"
                      alt="play"
                      className={classes.playButton}
                    />

                    {/*<PlayCircleFilledIcon className={classes.playButton} />*/}
                  </ButtonBase>
                </>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          )}
        </CardContent>
      </div>
      <CardContent className={classes.contentContainer}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="stretch"
        >
          <Grid item xs={12}>
            <Typography gutterBottom variant="body2">
              {props.recordedMeeting.longDescription}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          className={classes.authorContainer}
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={2}>
            <Avatar
              aria-label="author"
              src={props.recordedMeeting.authorImage}
              className={classes.avatar}
            >
              {props.recordedMeeting && props.recordedMeeting.authorName && (
                <>props.recordedMeeting.authorName.charAt(0)</>
              )}
            </Avatar>
          </Grid>
          <Grid item xs={8}>
            <Typography variant={"caption"} className={classes.authorName}>
              {messages["dashboard.live.byAuthor"][language]}
              {props.recordedMeeting.authorName}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <WhatsappShareButton
              url={`https://agrostar.onelink.me/9ngX/gold${props.userState?.code?.toLowerCase()}`}
              title={`${getShareText()}`}
              onClick={share}
              className={classes.shareIconContainer}
            >
              <img
                className={classes.shareIcon}
                src="../../icons/whatsapp.svg"
                alt="whatsapp-share"
              />
            </WhatsappShareButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    <ShareDialog
      handleClose={handleClose}
      sessionTopic={props.recordedMeeting.sessionTopic}
      week={props.recordedMeeting.week}
      shareText={`${messages["dashboard.upcoming.shareText"][language]}`}
      shortDescription={`${props.recordedMeeting.cropName} - ${props.recordedMeeting.shortDescription}`}
      url={window.location.href}
      handleOpen={handleClickOpen}
      open={openShareDialog}
      cropName={props.recordedMeeting.crop.name_en}
      authorName={props.recordedMeeting.author.name_en}
      mobile={mobile}
      position={props.position}
      userType={props.userType}
      state={props?.recordedMeeting?.state[0]?.name_en}
      startTime={props?.recordedMeeting.startTime}
      userSource={props?.userSource}
      classType={`recorded_class`}
    />
  </>;
}
